export const translateDate = ({ date, datetime }) => {
  if (date != undefined) {
    return new Date(date)
      .toISOString()
      .substr(0, 10)
      .split('-')
      .reverse()
      .join('/');
  } else if (datetime != undefined) {
    const time = datetime.split('T');
    return `${time[0]
      .substr(0, 10)
      .split('-')
      .reverse()
      .join('/')} às ${time[1].substr(0, 5)}`;
  }
  return new Date()
    .toISOString()
    .substr(0, 10)
    .split('-')
    .reverse()
    .join('/');
};

export default props => translateDate(props);



// WEBPACK FOOTER //
// ./src/components/Time/index.js